// Региональный отказ отличается от ожидания ответа и технического сбоя.
export function deliveryAreaDenied(order, types, selectedType, rx4route) {
  if (!rx4route) {
    return !types[selectedType]
  }
  const type = selectedType || order.deliver?.type
  return types[type] === false
}

export function deliveryFacilityName(order) {
  return order.facility?.name?.trim() || 'Your delivery provider'
}

// Только последний ответ может описывать текущий адрес формы.
export function createDeliveryChecker(fetchTypes, types, state) {
  let revision = 0
  return async (clientId, geo) => {
    const current = ++revision
    state.pending = true
    state.failed = false
    Object.keys(types).forEach(key => { delete types[key] })
    // Пока геокодер ищет координаты, сохраняем ожидание без ложной ошибки и запроса.
    if (!geo?.lat || !geo?.lng) {
      return
    }
    try {
      const result = await fetchTypes(clientId, geo)
      if (current === revision) {
        Object.assign(types, result)
      }
    } catch (error) {
      if (current === revision) {
        state.failed = true
      }
    } finally {
      if (current === revision) {
        state.pending = false
      }
    }
  }
}
